<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="$t('tSerialDetail')"
      ></el-page-header>
    </div>
    <h3 class="mt20 b">{{$t('serialList.serial_info')}}</h3>
    <el-card class="mt20">
      <el-form
        label-position="left"
        :model="ruleForm"
        ref="ruleForm"
        label-width="150px"
        class="ruleFrom row"
      >
        <el-form-item class="mb0 col-12" :label="$t('serialList.title')" prop="title">
          <div>{{ ruleForm.title }}</div>
        </el-form-item>
         <el-form-item class="mb0 col-12" :label="$t('serialList.book_desc')" prop="book_desc">
          <div>{{ ruleForm.book_desc }}</div>
        </el-form-item>
        <el-form-item class="mb0 col-12" :label="$t('serialList.cover')" prop="cover"
          >
          <el-image
            style="width: 100px; height: 100px"
            :src="ruleForm.cover"
            :preview-src-list="[ruleForm.cover]"
          >
          </el-image>
        </el-form-item>
        <el-form-item class="mb0 col-12" :label="$t('serialList.detail')" prop="detail">
          <div v-html="ruleForm.detail"></div>
        </el-form-item>
        <el-form-item class="mb0 col-12" :label="$t('serialList.tag')" prop="tag">
          <div>
              <span class="span" v-for="(item,index) in ruleForm.tag" :key="index">{{item}}</span>
          </div>
        </el-form-item>
        <el-form-item class="mb0 col-12" :label="$t('serialList.day_of_week')" prop="day_of_week">
          <div>
              <span class="span" v-for="(item,index) in ruleForm.day_of_week" :key="index">{{day_of_week(item)}}</span>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <h3 class="mt20 b">{{$t('serialList.author_info')}}</h3>
     <el-card class="mt20">
        <el-form label-position="left" :model="ruleForm" ref="ruleForm" label-width="150px" class="ruleFrom row">
            <el-form-item :label="$t('serialList.author_name')" prop="author_name" class="col-12 mb0">
                <div>{{ruleForm.author_name}}</div>
            </el-form-item>
            <el-form-item :label="$t('serialList.author_desc')" prop="author_desc" class="col-12 mb0">
                <div>{{ruleForm.author_desc}}</div>
            </el-form-item>
            <el-form-item :label="$t('serialList.author_img')" prop="author_img" class="col-12 mb0">
                 <el-image
            style="width: 100px; height: 100px"
            :src="ruleForm.author_img"
            :preview-src-list="[ruleForm.author_img]"
          >
          </el-image>
            </el-form-item>
        </el-form>
    </el-card>
    <h3 class="mt20 b">{{$t('serialList.serial_setting')}}</h3>
     <el-card class="mt20">
        <el-form label-position="left" :model="ruleForm" ref="ruleForm" label-width="150px" class="ruleFrom row">
           <!-- <el-form-item :label="$t('serialList.is_recommend')" prop="is_recommend" class="col-6 mb0">
                <div>{{is_recommend(ruleForm.is_recommend)}}</div>
            </el-form-item> -->
            <el-form-item :label="$t('serialList.is_switch_on')" prop="is_switch_on" class="col-6 mb0">
                <div>{{is_switch_on(ruleForm.is_switch_on)}}</div>
            </el-form-item>
            <el-form-item :label="$t('serialList.status')" prop="status" class="col-6 mb0">
                <div>{{status(ruleForm.status)}}</div>
            </el-form-item>
            <el-form-item :label="$t('serialList.active')" prop="active" class="col-6 mb0">
                <div>{{active(ruleForm.active)}}</div>
            </el-form-item>
            <el-form-item :label="$t('serialList.link')" prop="link" class="col-12 mb0">
                <div>{{ruleForm.link}}</div>
            </el-form-item>
        </el-form>
    </el-card>
  </div>
</template>
<script>
import { serialDetail } from "@/api/api";
export default {
  name: "serialDetail",
  data() {
    return {
      ruleForm: {
        
      },
    };
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    }
  },
  methods: {
      day_of_week(day_of_week){
          switch(day_of_week){
              case '0':
                  return this.$t('day1')
                  case '1':
                  return this.$t('day2')
                  case '2':
                  return this.$t('day3')
                  case '3':
                  return this.$t('day4')
                  case '4':
                  return this.$t('day5')
          }
      },
      // is_recommend(is_recommend){
      //     switch(is_recommend){
      //         case 0:
      //             return this.$t('serialList.recommend0')
      //           case 1:
      //             return this.$t('serialList.recommend1')
      //     }
      // },
      is_switch_on(is_switch_on){
          switch(is_switch_on){
              case 0:
                  return this.$t('serialList.switch_on0')
                case 1:
                  return this.$t('serialList.switch_on1')
          }
      },
      status(status){
          switch(status){
              case 0:
                  return this.$t('serialList.status0')
                case 1:
                  return this.$t('serialList.status1')
          }
      },
      active(active){
          switch(active){
              case 0:
                  return this.$t('serialList.active0')
                case 1:
                  return this.$t('serialList.active1')
          }
      },
    async get_info() {
      const information = await serialDetail(this.id);
      this.ruleForm = { ...information };
    },
  },
  async created() {
    if (this.id === undefined) return;
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.span + .span::before{
    content:'/'
}
</style>
